import script from "./EmojiPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmojiPicker.vue?vue&type=script&lang=ts&setup=true"

import "./EmojiPicker.vue?vue&type=style&index=0&id=76e578e2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76e578e2"]])

export default __exports__